module.exports = __webpack_public_path__ + "img/info-clover-2.3ea81709.svg";